<template>
  <div class="mate-stic">
    <div class="mate-head typeClass">
      <div v-for="(item,index) in list" :key="index" style="margin-right: 80px;">
        <el-button :class="{'cur':checkStatus==item.checkStatus}" @click="searchType(item.checkStatus)">
          <div>{{item.name}}</div>
        </el-button>
        <div v-if="item.checkStatus==1" class="round">{{waitDo}}</div>
        <div v-if="item.checkStatus==3" class="round">{{ongoingDo}}</div>
        <div v-if="item.checkStatus==2" class="round">{{finishDo}}</div>
      </div>
    </div>
    <!--  -->
    <div class="mate-main">
      <div class="main-item" v-for="(item,index) in listData" :key="index">
        <img :src="http+item.description" style="height:25vh;width:auto;cursor: pointer;" @click="toPage(item)" />
        <p style="width:100%;height:4vh;position: relative;text-align: center;">{{item.index}}.{{item.label}}</p>
      </div>

    </div>
  </div>
</template>
<script>
  import myHttp from '../../untils/port'
  import util from '../../untils/util'
  import base from '../../untils/base'
  export default {
    data() {
      var checkphone = (rule, value, callback) => {
        if (value == '') {
          callback(new Error('请输入手机号'))
        } else if (!this.isCellPhone(value)) {
          //引入methods中封装的检查手机格式的方法
          callback(new Error('请输入正确的手机号!'))
        } else {
          callback()
        }
      }
      return {
        http:base.httpCtx,
        checkStatus:'1',
        list:
          [{ name: '待处理', checkStatus: '1' },
          { name: '进行中', checkStatus: '3' },
          { name: '已完成', checkStatus: '2' },
          ],
          waitDo: 0,
          ongoingDo: 0,
          finishDo: 0,
        listData: [
          // { name: '1.工程指令单', url: require('../../assets/image/table/1.jpg'), href: '/table1' },
          // { name: '2.工程指令审批表', url: require('../../assets/image/table/2.jpg'), href: '/table2' },
          // { name: '3.工程签证表', url: require('../../assets/image/table/3.jpg'), href: '/table3' },
          // { name: '4.工程签证审批表', url: require('../../assets/image/table/4.jpg'), href: '/table4' },
          // { name: '5.签证内容完工验收记录', url: require('../../assets/image/table/5.jpg'), href: '/table5' },
          // { name: '6.工程签证审批汇总表', url: require('../../assets/image/table/6.jpg'), href: '/table6' },
          // { name: '7.设计变更测算表', url: require('../../assets/image/table/7.jpg'), href: '/table7' },
          // { name: '8.工程进度款申请表', url: require('../../assets/image/table/8.jpg'), href: '/table8' },
          // { name: '9.工程签形象进度表', url: require('../../assets/image/table/9.jpg'), href: '/table9' },
          // { name: '10.工程支付审批表', url: require('../../assets/image/table/10.jpg'), href: '/table10' },
          // { name: '11.工程结算审批表', url: require('../../assets/image/table/11.jpg'), href: '/table11' },
          // { name: '12.设计变更审批表', url: require('../../assets/image/table/12.jpg'), href: '/table12' },
          // { name: '13.工程联系单', url: require('../../assets/image/table/13.jpg'), href: '/table13' },
          // { name: '14.技术核定单', url: require('../../assets/image/table/14.jpg'), href: '/table14' },
        ],
        project_purchase:'',
        port:'',
        groupType:''
      }
    },
    watch: {
      '$store.state.roleStatus': function () {
        // this.processStatus = util.session.get('roleStatus').project_purchase
        // this.getRole()
        // this.getPiaoType()
        this.getData()
      },
      // listData(val) {
      //   // console.log(val)
      //   this.doLayout()
      // }
    },
    created() {
      this.groupId = util.session.get('groupId')
      var role= util.session.get('roleId');
      if(role==4){
        this.groupType =2
      }else if(role==5){
        this.groupType =1
      }
      // this.processStatus = util.session.get('roleStatus').project_purchase
      // this.getRole()
    },
    mounted() {
      // console.log(this.processStatus) 
      // this.uploadData.projectId = this.groupId
      this.port = util.session.get('roleId')
      console.log(this.port)
      this.getWayCount()
      this.getTree()
      // this.getPiaoType()
      // this.getRole()
      // // this.getData()   
      // this.doLayout()
    },
    methods: {
      getTree(){
      var that = this
      myHttp
        .findSpTableInformationList({
          groupId :  this.groupId,
           groupType: this.groupType
        })
        .then(function(resp) {
          if (resp.data.code == '200') {        
             var list = resp.data.data
             for(var i = 0;i<list.length;i++){
                list[i].index = i+1
              }
              that.listData = resp.data.data
          } else {
            that.$message.error(resp.data.msg)
          }
        })

    },
      //查询
      doFilter() {
        this.currentPage = 1
        this.getData()
      },
      
      // 查询未处理数量
      getCount(processStatus) {
        var that = this
        // console.log(processStatus)
        myHttp.waitDoWithCount({
          processStatus: processStatus,
          project: this.groupId
        }).then(function (resp) {
          if (resp.data.code == '200') {
            // console.log(resp)
            that.unDealCount = resp.data.data
          }
        })
      },
      // 查询未完成数量
      getWayCount(processStatus) {
        var that = this
        // console.log(processStatus)
        myHttp.spTableLinkCount({
          // processStatus: processStatus,
          groupId: this.groupId,
          groupType:this.groupType
        }).then(function (resp) {
          if (resp.data.code == '200') {
            console.log(resp)
            that.finishDo = resp.data.data.finishDo
            that.ongoingDo = resp.data.data.ongoingDo
            that.waitDo = resp.data.data.waitDo
          }
        })
      },
      searchType(checkStatus) {
        // console.log(checkStatus)
        this.checkStatus = checkStatus
        if(this.port == 4){
          if(checkStatus == 1){
          this.$router.push({ path: '/untreated' })
          }else if(checkStatus == 2){
            this.$router.push({ path: '/finishProject' })
          }else{
            this.$router.push({ path: '/unfinishProject' })
           }
        }else{
          if(checkStatus == 1){
          this.$router.push({ path: '/untreatedEnt' })
          }else if(checkStatus == 2){
            this.$router.push({ path: '/finishProjectEnt' })
          }else{
            this.$router.push({ path: '/unfinishProjectEnt' })
           }   
        }
        
        
        // this.getData()
      },
  
      // 
      change(e) {
        this.$forceUpdate()
      },
      beforeRemove(file, fileList) {
        var that = this
        console.log(fileList)
      },
      // 获取登录人权限
      // findCompanyUserRoleList
      getRole() {
        var that = this
        var roleProcessMap = ''
        myHttp.findCompanyUserRoleList({
          project: this.groupId
        }).then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data
            var roleProcessMap = list[0].roleProcessMap
            // for(var i = 0;i<list.length;i++){
            //   if(list[i].remarks&&(list[i].remarks==1||list[i].remarks==2||list[i].remarks==3||list[i].remarks==4||list[i].remarks==5||list[i].remarks==6||list[i].remarks==7)){
            //     console.log(list[i].remarks)
            //     roleStatus = list[i].remarks
            //   }
            // }
            roleProcessMap = list[0].roleProcessMap
            that.processStatus = roleProcessMap.project_purchase
            util.session.set('roleStatus', roleProcessMap)
            that.$store.commit('setRoleStatus')
            that.getCount(that.processStatus)
            that.getWayCount()
            that.getData()
          } else {
            that.dataText = '暂无数据'
          }
        })
      },
       //跳转
       toPage(row){
         var type = row.value
         var path = row.remark
         var pathent = row.remark +'Ent'
        if(this.port == 4){
          this.$router.push(path + '/'+type)    
        }else{
          this.$router.push(pathent + '/'+type)
        }

        
        },
    }
  }
</script>

<style scoped>
  .mate-stic {
    width: 100%;
    height: 100%;
    position: relative;
    padding: 1vh;
    overflow: auto;
  }

  .title-crumb {
    width: 100%;
    height: 4vh;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    padding-left: 1vw;
  }

  .mate-head {
    width: 100%;
    height: 8vh;
    position: relative;
    background: #fff;
    padding: 2vh 1vw 1vh;
    display: flex;
    /* justify-content: flex-start;
      justify-items: flex-start; */
    justify-content: space-between;
    align-content: center;
    align-items: center;
    border-bottom: 5px solid #ecf0f5;
  }

  /* .mate-head-left{
      width: 7vw;
      position: relative;
      text-align: right;
      padding: 1vh 0;
  }
  .mate-head-r{
      width: calc( 100% - 10vw );
      position: relative;
      height: 5vh;
      overflow: hidden;
  }
  .mate-head-r.showAll{
      height: auto;
  }
  .mate-head-r-item{
      width: auto;
      position: relative;
      margin-right: 2vh;
      display: flex;
      align-items: center;
      float: left;
      margin-bottom: 1vh;
      cursor: pointer;
      color: #3E50B4;
      padding: 1vh 1vw;
      border-radius: 5px;
  }
  .mate-head-r-item:hover{
      background: #0490F9;
      color: #fff;
  }
  .mate-head-r-item.cur{
      background: #0490F9;
      color: #fff;
  }
  .mate-head-bottom{
      width: 3vw;
      display: flex;
      justify-items: flex-end;
      align-items: flex-end;
      min-height: 5vh;
      padding-bottom: 1vh;
      cursor: pointer;
  } */

  .mate-main {
    width: 100%;
    height: calc(100% - 8vh);
    position: relative;
    background: #fff;
    display: flex;
    justify-content: flex-start;
    justify-items: self-start;
    align-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    overflow: auto;
  }

  .round {
    position: absolute;
    background: #f00;
    color: #fff;
    border-radius: 50%;
    z-index: 1000;
    padding: 4px;
    left: 88px;
    top: -10px;
    font-size: 10px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .cur {
    background: #3d63f6;
    color: #fff;
  }

  .typeClass {
    justify-content: start;
  }

  .color1 {
    color: #f00;
  }

  .main-item {
    width: 20%;
    height: 36vh;
    position: relative;
    display: flex;
    justify-content: center;
    justify-items: center;
    flex-wrap: wrap;
  }

</style>

<style>

</style>